<template>
  <AppView
    padd-bottom
  >
    <TopNav
      slot="top-app-view"
      title="Frequently Asked Questions For Mentors"
      title-class="lg:ml-body lg-app:tw-font-bold"
      type="menu"
      @input="openSideNav()"
    />

    <FAQMentor />
  </AppView>
</template>

<script>
import FAQMentor from '@/views/_partials/FAQMentor.vue';

export default {
  name: 'FAQMentorView',
  components: {
    FAQMentor,
  },
};
</script>

<style>

</style>
